export const adoptionTypeModelData = function () {
  return {
    adoptionTypeList: []
  }
}
